import React from 'react';
import { CardData } from 'types/story';
import { Context } from 'client/components/common/SelectionHint/SelectionHintContext';
import { TRAVERSE_TREE_TARGETS } from 'client/components/common/BuildingBlocks/utils/common';
import { StoryFacade } from 'common/utils/facades/story-facade';
import Card from './Card';

type Props = {
	data: CardData;
	story: StoryFacade;
};

class CardEditable extends React.Component<Props> {
	static contextType = Context;

	get treeOptions() {
		return {
			target: TRAVERSE_TREE_TARGETS.EDITOR,
			isCardTree: true,
			onMouseDown: this.context.treeOptions.onMouseDown,
			onFocus: this.context.treeOptions.onFocus,
			onMouseEnter: this.context.treeOptions.onMouseEnter,
			onMouseLeave: this.context.treeOptions.onMouseLeave,
			onMouseDownCapture: this.context.treeOptions.onMouseDownCapture,
			onDoubleClickCapture: this.context.treeOptions.onDoubleClickCapture,
		};
	}

	onCardClick = e => {};

	render() {
		return (
			<Card
				card={this.props.data}
				treeOptions={this.treeOptions}
				onCardClick={this.onCardClick}
				isEditor
				story={this.props.story}
			/>
		);
	}
}

export default CardEditable;
